import IDoubleChanceData from '../src/server/interface/IDoubleChanceData';
import { BaseModel } from "../../vendor_core/core/src/model/BaseModel";
class DoubleChanceModel extends BaseModel<IDoubleChanceData> {
    public isActivated: boolean = false;
    public mode: number = 0;
}

export default new DoubleChanceModel()
